import { CampaignsTracker } from 'marketing-tracker';
import appConfig from 'src/utils/appConfig';

export default function() {
  const { goBaseUrl } = appConfig.getMyConfig();
  const campaignsTracker = new CampaignsTracker({ host: goBaseUrl });
  campaignsTracker.trackUserClick();
}
